import Vue from "vue";

export const NumericFilter = () => {
    Vue.directive('digitsonly', (el, binding) => {
        let newValue = el.value.replace(/[^\d.]/g, '')
        if (newValue.indexOf('.') < 0 && newValue != '') {
          newValue = parseInt(newValue);
       }
        el.value = newValue;
        return newValue
    });
  };


// WEBPACK FOOTER //
// ./src/Filters/numericFilters.js